export default __webpack_public_path__ + "static/media/banner_Wsct6julio.57198b97.jpg";